/* eslint-disable */
import { CallContext, CallOptions } from 'nice-grpc-common';
import { ProfileDownstreamEvent, PreferenceDownstreamEvent } from '../../common/DownstreamProfileProto';
import {
    DeletePreferenceRequest,
    PersistPreferenceRequest,
    FindPreferencesForProfileIdRequest,
    CreateProfileRequest
} from '../../common/UpstreamProfileProto';
import { ServerAckEvent } from '../../../marketmaker/api/services/MarketMakerCommonProto';
import { Empty } from '../../../../../google/protobuf/empty';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.preference.api.profile';

/** Don't declare username for safety - we can retrieve it via the headers on the auth token */
export interface FindProfilesByUsernameAndTypeSecure {
    type: string;
}

export interface ProfilesCollection {
    profile: ProfileDownstreamEvent[];
}

export interface PreferencesCollection {
    preference: PreferenceDownstreamEvent[];
}

export interface DeletePreferencesCollection {
    preference: DeletePreferenceRequest[];
}

export interface PersistPreferenceRequestCollection {
    preferenceRequest: PersistPreferenceRequest[];
}

function createBaseFindProfilesByUsernameAndTypeSecure(): FindProfilesByUsernameAndTypeSecure {
    return { type: '' };
}

export const FindProfilesByUsernameAndTypeSecure = {
    encode(message: FindProfilesByUsernameAndTypeSecure, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.type !== '') {
            writer.uint32(10).string(message.type);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): FindProfilesByUsernameAndTypeSecure {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindProfilesByUsernameAndTypeSecure();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<FindProfilesByUsernameAndTypeSecure>): FindProfilesByUsernameAndTypeSecure {
        const message = createBaseFindProfilesByUsernameAndTypeSecure();
        message.type = object.type ?? '';
        return message;
    }
};

function createBaseProfilesCollection(): ProfilesCollection {
    return { profile: [] };
}

export const ProfilesCollection = {
    encode(message: ProfilesCollection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.profile) {
            ProfileDownstreamEvent.encode(v!, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): ProfilesCollection {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProfilesCollection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.profile.push(ProfileDownstreamEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<ProfilesCollection>): ProfilesCollection {
        const message = createBaseProfilesCollection();
        message.profile = object.profile?.map((e) => ProfileDownstreamEvent.fromPartial(e)) || [];
        return message;
    }
};

function createBasePreferencesCollection(): PreferencesCollection {
    return { preference: [] };
}

export const PreferencesCollection = {
    encode(message: PreferencesCollection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.preference) {
            PreferenceDownstreamEvent.encode(v!, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): PreferencesCollection {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePreferencesCollection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.preference.push(PreferenceDownstreamEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<PreferencesCollection>): PreferencesCollection {
        const message = createBasePreferencesCollection();
        message.preference = object.preference?.map((e) => PreferenceDownstreamEvent.fromPartial(e)) || [];
        return message;
    }
};

function createBaseDeletePreferencesCollection(): DeletePreferencesCollection {
    return { preference: [] };
}

export const DeletePreferencesCollection = {
    encode(message: DeletePreferencesCollection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.preference) {
            DeletePreferenceRequest.encode(v!, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): DeletePreferencesCollection {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeletePreferencesCollection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.preference.push(DeletePreferenceRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<DeletePreferencesCollection>): DeletePreferencesCollection {
        const message = createBaseDeletePreferencesCollection();
        message.preference = object.preference?.map((e) => DeletePreferenceRequest.fromPartial(e)) || [];
        return message;
    }
};

function createBasePersistPreferenceRequestCollection(): PersistPreferenceRequestCollection {
    return { preferenceRequest: [] };
}

export const PersistPreferenceRequestCollection = {
    encode(message: PersistPreferenceRequestCollection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.preferenceRequest) {
            PersistPreferenceRequest.encode(v!, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): PersistPreferenceRequestCollection {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistPreferenceRequestCollection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.preferenceRequest.push(PersistPreferenceRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<PersistPreferenceRequestCollection>): PersistPreferenceRequestCollection {
        const message = createBasePersistPreferenceRequestCollection();
        message.preferenceRequest = object.preferenceRequest?.map((e) => PersistPreferenceRequest.fromPartial(e)) || [];
        return message;
    }
};

export type PreferenceServiceDefinition = typeof PreferenceServiceDefinition;
export const PreferenceServiceDefinition = {
    name: 'PreferenceService',
    fullName: 'com.celertech.preference.api.profile.PreferenceService',
    methods: {
        findProfilesByUsernameAndType: {
            name: 'findProfilesByUsernameAndType',
            requestType: FindProfilesByUsernameAndTypeSecure,
            requestStream: false,
            responseType: ProfilesCollection,
            responseStream: false,
            options: {}
        },
        findPreferencesForProfileId: {
            name: 'findPreferencesForProfileId',
            requestType: FindPreferencesForProfileIdRequest,
            requestStream: false,
            responseType: PreferencesCollection,
            responseStream: false,
            options: {}
        },
        createProfileRequest: {
            name: 'createProfileRequest',
            requestType: CreateProfileRequest,
            requestStream: false,
            responseType: ProfileDownstreamEvent,
            responseStream: false,
            options: {}
        },
        createPreferenceRequest: {
            name: 'createPreferenceRequest',
            requestType: PersistPreferenceRequest,
            requestStream: false,
            responseType: ServerAckEvent,
            responseStream: false,
            options: {}
        },
        createPreferenceRequestBatch: {
            name: 'createPreferenceRequestBatch',
            requestType: PersistPreferenceRequestCollection,
            requestStream: false,
            responseType: ServerAckEvent,
            responseStream: false,
            options: {}
        },
        deletePreferenceRequest: {
            name: 'deletePreferenceRequest',
            requestType: DeletePreferenceRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {}
        },
        deletePreferenceRequestBatch: {
            name: 'deletePreferenceRequestBatch',
            requestType: DeletePreferencesCollection,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {}
        }
    }
} as const;

export interface PreferenceServiceServiceImplementation<CallContextExt = {}> {
    findProfilesByUsernameAndType(
        request: FindProfilesByUsernameAndTypeSecure,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<ProfilesCollection>>;
    findPreferencesForProfileId(
        request: FindPreferencesForProfileIdRequest,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<PreferencesCollection>>;
    createProfileRequest(
        request: CreateProfileRequest,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<ProfileDownstreamEvent>>;
    createPreferenceRequest(
        request: PersistPreferenceRequest,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<ServerAckEvent>>;
    createPreferenceRequestBatch(
        request: PersistPreferenceRequestCollection,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<ServerAckEvent>>;
    deletePreferenceRequest(
        request: DeletePreferenceRequest,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<Empty>>;
    deletePreferenceRequestBatch(
        request: DeletePreferencesCollection,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<Empty>>;
}

export interface PreferenceServiceClient<CallOptionsExt = {}> {
    findProfilesByUsernameAndType(
        request: DeepPartial<FindProfilesByUsernameAndTypeSecure>,
        options?: CallOptions & CallOptionsExt
    ): Promise<ProfilesCollection>;
    findPreferencesForProfileId(
        request: DeepPartial<FindPreferencesForProfileIdRequest>,
        options?: CallOptions & CallOptionsExt
    ): Promise<PreferencesCollection>;
    createProfileRequest(
        request: DeepPartial<CreateProfileRequest>,
        options?: CallOptions & CallOptionsExt
    ): Promise<ProfileDownstreamEvent>;
    createPreferenceRequest(
        request: DeepPartial<PersistPreferenceRequest>,
        options?: CallOptions & CallOptionsExt
    ): Promise<ServerAckEvent>;
    createPreferenceRequestBatch(
        request: DeepPartial<PersistPreferenceRequestCollection>,
        options?: CallOptions & CallOptionsExt
    ): Promise<ServerAckEvent>;
    deletePreferenceRequest(
        request: DeepPartial<DeletePreferenceRequest>,
        options?: CallOptions & CallOptionsExt
    ): Promise<Empty>;
    deletePreferenceRequestBatch(
        request: DeepPartial<DeletePreferencesCollection>,
        options?: CallOptions & CallOptionsExt
    ): Promise<Empty>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;
